import { Fragment, PureComponent } from 'react';
import {
  getArticles,
  getCollections,
  getCategories,
  getPublished,
  getLink,
} from 'constants/helpCenter';
import { get, uniq, slice, flatten } from 'lodash-es';

import WithScroll from 'hocs/WithScroll';

import ArticleSearchPreview from '../ArticleSearchPreview';
import ArticleSearchNoMatch from '../ArticleSearchNoMatch';

const defaultProps = {
  location: {
    state: {
      result: [],
    },
  },
};

class SearchResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { result: [], fetching: true, limit: 10 };
  }

  componentDidMount() {
    if (this.props.input) {
      return;
    }

    this.setState({ fetching: false });
  }

  async componentDidUpdate({ options }) {
    if (this.props.options !== options) {
      await this.getData();
    }
  }

  async getData() {
    const { options } = this.props;
    this.setState({ fetching: true });

    const foundInCategories = uniq(
      options.reduce((acc, item) => {
        return [...acc, ...item.categoryIds];
      }, [])
    );

    const collections = get(
      await getCollections(),
      'data.collections.items',
      []
    ).map(({ id, name, slug }) => ({ id, name, collectionSlug: slug }));

    let categories = await Promise.all(
      collections.map(async collection => {
        const categories = get(
          await getCategories(collection.id),
          'data.categories.items',
          []
        );

        return await Promise.all(
          categories
            .filter(category => foundInCategories.includes(category.id))
            .map(async ({ id, name }) => ({
              id,
              name,
              articles: await getArticles(id),
            }))
            .concat(collection)
        );
      })
    );

    categories = flatten(categories);

    const articles = getPublished(options).map(article => {
      const category = categories.find(
        item => item.id === article.categoryIds[0]
      );
      return {
        ...article,
        collectionName: categories.find(
          item => item.id === article.collectionId
        ).name,
        categoryName: category.name,
        collectionSlug: categories.find(
          item => item.id === article.collectionId
        ).collectionSlug,
        categoryFirstArticle: get(
          category,
          'articles.data.articles.items[0].slug'
        ),
      };
    });

    this.setState({ result: articles, fetching: false });
  }

  handleArticleSelect = (event, collectionSlug, slug) => {
    const { history } = this.props;
    event.preventDefault();
    history.push(getLink(collectionSlug, slug));
  };

  handleLimitButton = event => {
    event.preventDefault();
    const { limit, result } = this.state;
    const isFull = limit > 10;
    const prevPosition = this.props.scroll.getScrollTop();

    this.setState({ limit: isFull ? 10 : result.length }, () => {
      !isFull && this.props.scroll.scrollTo(prevPosition);
      this.props.scroll.update();
    });
  };

  render() {
    const { result, fetching, limit } = this.state;
    const { input } = this.props;
    return fetching ? (
      <div className="spinner section__spinner" />
    ) : (
      <Fragment>
        <div className="section__quantity">
          {`${result.length} result${result.length === 1 ? '' : 's'} found`}
        </div>
        <div className="section__result">
          {result.length ? (
            slice(result, 0, limit).map((article, index) => (
              <div
                className={cx('section__result-item', {
                  'section__result-item_last': index + 1 === limit,
                })}
                key={article.id}
              >
                <ArticleSearchPreview
                  {...article}
                  onArticleClick={e =>
                    this.handleArticleSelect(
                      e,
                      article.collectionSlug,
                      article.slug
                    )
                  }
                />
              </div>
            ))
          ) : (
            <ArticleSearchNoMatch inputResult={input} />
          )}
        </div>
        {result.length > 10 && (
          <div className="section__btn-wrap">
            <button
              className="btn btn_grey section__btn-more"
              onClick={this.handleLimitButton}
            >
              {limit > 10 ? 'Show less' : 'Show more results'}
            </button>
          </div>
        )}
      </Fragment>
    );
  }
}

SearchResult.defaultProps = defaultProps;

export default WithScroll(SearchResult);
